import { ErrorMessage } from '@hookform/error-message';
import { useEffect } from 'react';
import { RegisterOptions, useFormContext } from 'react-hook-form';

export interface CheckboxInputProps extends ICheckboxField {
  rules?: RegisterOptions;
  className?: string;
  flexDirection?: 'flex-col' | 'flex-row' | '';
}
export const CheckboxInput = ({
  name,
  rules,
  label,
  effect,
  className = '',
  flexDirection = 'flex-col',
}: CheckboxInputProps) => {
  const {
    register,
    formState: { errors },
    getValues,
    watch,
  } = useFormContext();

  const isChecked = watch(name);

  useEffect(() => {
    // if (effect && getValues(name) !== null && getValues(name) !== undefined) {
    effect && effect({ key: name, value: getValues(name) });
    // }
  }, [isChecked, name, getValues]);

  return (
    <div className={`py-3 flex w-full items-center gap-2 ${flexDirection}`}>
      <label
        className={`cursor-pointer inline-flex w-full items-center font-medium text-sm  ${className}`}
      >
        <input
          type="checkbox"
          className="cursor-pointer form-checkbox w-5 h-5 border-0 text-green bg-gray-800 rounded focus:ring-0 focus:ring-offset-0"
          {...register(name, rules)}
        />
        {label && (
          <span className="ml-3 font-normal text-gray-dark">
            {typeof label === 'string' ? label : label()}
          </span>
        )}
      </label>
      <ErrorMessage
        errors={errors}
        name={name}
        render={({ message }) => (
          <p className="text-red-dark text-xs bg-red-100 rounded-xl w-full border p-1 capitalize pl-4">
            {message}
          </p>
        )}
      />
    </div>
  );
};
